import { render } from "./RecentlyViewed.vue?vue&type=template&id=54e099f1&scoped=true"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"

import "./RecentlyViewed.vue?vue&type=style&index=0&id=54e099f1&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e099f1"]])

export default __exports__